<template>
    <v-dialog :value="value" @input="$emit('input', false)" max-width="400">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>

            <v-card-text>
                <v-form @submit.prevent="save" ref="form" v-model="valid">
                    <v-text-field
                        ref="inputField"
                        v-model="input"
                        :label="label"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="$emit('input', false)" text>Batal</v-btn>
                <v-btn @click="save" text color="primary">Simpan</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['value', 'title', 'label', 'initialValue'],

    data() {
        return {
            input: 'something',

            valid: null,

            fieldRules: [
                v => !!v || `${this.label} harus diisi`
            ]
        }
    },

    watch: {
        value(to) {
            if (to) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.form.reset()

                        if (this.initialValue) {
                            this.input = this.initialValue
                        }

                        this.$refs.inputField.focus()
                    })
                })
            }
        },
    },

    methods: {
        save() {
            if (this.valid) {
                this.$emit('save', this.input)
                this.$emit('input', false)
            }
        }
    },
}
</script>
